module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/930e381b91c4c805e09d3551665a3f67.png";